<template>
    <div>
        <loader v-if="isLoading" />

        <div class="page-container form-columns-fit">
            <div class="columns is-flex-wrap">
                    <div class="column is-12">
                    <v-input
                        ref="descricaoInput"
                        v-model="pro_contrato.descricao"
                        placeholder="descricao-contrato-placeholder"
                        :maxlength="100"
                        title="descricao-contrato"
                        msg="msg-campo-obrigatorio"
                        :invalid="isNull(pro_contrato.descricao)"
                        position="is-right"
                        type="is-dark"
                        size="is-large"
                        multilined
                        required
                    />
                </div>

                <div class="column is-4">
                    <vss-select
                        ref="tiposervicoInput"
                        v-model="tiposervicoSelected"
                        title="tipo-servico-contrato"
                        placeholder="tipo-servico-contrato-placeholder"
                        :options="tiposervicoSelect"
                        :invalid="isNull(tiposervicoSelected)"
                        label="descricao"
                        :loading="tipoServicoLoading"
                        @search="loadTipoServicos"
                        searchable
                        required
                    />
                </div>

                <div class="column is-4">
                    <v-money
                        ref="diasInput"
                        title="dias"
                        v-model="pro_contrato.diaspadrao"
                        :invalid="isNull(pro_contrato.diaspadrao)"
                        :max="7"
                        :min="1"
                        :precision="0"
                        alingCenter
                        placeholder="dias-placeholder"
                        tooltipLabel="helper-contrato-cliente-dias"
                        required
                    />
                </div>

                <div class="column is-4">
                        <VerifiedTimePicker
                            close-on-complete
                            manual-input
                            ref="horasDiaInput"
                            title="horas-dia"
                            v-model="horaTemp"
                            required
                            :invalid="horaTemp.HH == '' || horaTemp.mm == ''"
                            hideClearButton
                            tooltipPosition="is-left"
                            tooltipLabel="helper-contrato-cliente-diashoras"
                        />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TipoServicoService from '@/services/promotor/TipoServicoService.js';
import ProContratoService from '@/services/promotor/pro_cliente/ProContratoService.js';
import Message from '@/models/Message.js';
import Validation from '@/services/validations/ProClienteContratoValidation.js';
import VerifiedTimePicker from '@/components/shared/form/VerifiedTimePicker.vue';

export default {
    components: {
        VerifiedTimePicker,
    },
    props: {
        idcontrato: {
            type: Number,
            default: 0,
        },
        permissao: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            service: new ProContratoService(this.$http, this.$router),
            tiposervicoservice: new TipoServicoService(this.$http, this.$router),
            validation: new Validation(),
            pro_contrato: {
                id: null,
                descricao: null,
                diaspadrao: 1,
                pro_contrato_horasdiapadrao: '',
                idcliente: +this.$route.params.id,
                idcontrato: null,
                idcontratoerp: null,
                situacao: null,
                idtiposervico: null,
            },
            tipoServicoLoading: false,
            tiposervicoSelect: [],
            tiposervicoSelected: null,
            isSaving: false,
            isLoading: false,

            horaTemp: {
                HH: '',
                mm: '',
            },
        };
    },
    created() {
        if (this.idcontrato != 0) {
            this.carregarDados();
        }
    },
    methods: {
        carregarDados() {
            this.isLoading = true;
            this.service
                .find(this.idcontrato)
                .then((body) => {
                    this.pro_contrato = body.content;
                    if (this.pro_contrato.tiposervico) {
                        this.tiposervicoSelected = this.pro_contrato.tiposervico;
                    }
                })
                .catch((e) => {
                    this.$root.msgs.push(new Message('error', 'msg-erro-carregar-cliente', true));
                })
                .finally((_) => {
                    this.isLoading = false;

                    if (!this.isNull(this.pro_contrato.horasdiapadrao)) {
                        let temp = this.$moment(this.pro_contrato.horasdiapadrao, 'HH:mm');
                        let horaFimTemp = new Date(temp);

                        this.horaTemp.HH =
                            horaFimTemp.getHours() < 10
                                ? '0' + horaFimTemp.getHours().toString()
                                : horaFimTemp.getHours().toString();
                        this.horaTemp.mm =
                            horaFimTemp.getMinutes() < 10
                                ? '0' + horaFimTemp.getMinutes().toString()
                                : horaFimTemp.getMinutes().toString();
                    }
                });
        },
        save() {
            this.isSaving = true;
            this.$emit('isSaving', true);
            this.pro_contrato.idtiposervico =
                this.tiposervicoSelected != null ? this.tiposervicoSelected.id : null;

            this.pro_contrato = this.mapTosave(this.pro_contrato, 'horasdiapadrao');

            if (!this.validation.validate(this.pro_contrato, this.$refs, this.$root, this.horaTemp)) {
                this.isSaving = false;
                this.$emit('isSaving', false);
                return;
            }

            this.pro_contrato.horasdiapadrao =
                this.horaTemp.HH != '' && this.horaTemp.mm != ''
                    ? this.horaTemp.HH + ':' + this.horaTemp.mm
                    : null;

            this.service
                .save(this.pro_contrato)
                .then((body) => {
                    let msg = this.$t(this.idcontrato != 0
                            ? 'msg-edit-sucesso-n'
                            : 'msg-save-sucesso-n',
                        { n: this.$t('contrato') }
                    );
                    this.$root.showMessage('success', msg, true, false);
                    this.$emit('reloadData', true);

                    if (this.idcontrato == 0) this.$emit('idcontrato', body.content.id);
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-problema-realizar-acao');
                })
                .finally((_) => {
                    this.isSaving = false;
                    this.$emit('isSaving', false);
                });
        },

        loadTipoServicos(q) {
            this.tipoServicoLoading = true;

            this.tiposervicoservice
                .findAll('descricao', 'asc', 0, 100, 2, q ? q : '')
                .then((body) => {
                    this.tiposervicoSelect = body.content;
                })
                .finally((_) => {
                    this.tipoServicoLoading = false;
                });
        },

        addHours(date, hours) {
            date.setHours(date.getHours() + hours);
            return date;
        },
    },
};
</script>
<style lang="scss" scoped>
    .flex-campo {
        display: flex;
        justify-content: flex-end;
        flex-direction: column;
        align-self: center;
    }
</style>